import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import LogoMark from "@/components/LogoMark";

// One-time intro splash with the infinity mark + wordmark reveal.
export default function SplashScreen() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    return !window.sessionStorage.getItem("clt_splash_seen");
  });

  useEffect(() => {
    if (!show) return;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => {
      window.sessionStorage.setItem("clt_splash_seen", "1");
      setShow(false);
      document.body.style.overflow = "";
    }, 2200);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
    };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="splash-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center overflow-hidden bg-ink-950"
        >
          <div className="absolute inset-0 grid-lines opacity-50" aria-hidden="true" />
          <div
            className="pointer-events-none absolute h-[420px] w-[420px] rounded-full opacity-40 blur-[120px]"
            style={{ background: "radial-gradient(circle, rgba(0,240,255,0.3), transparent 70%)" }}
            aria-hidden="true"
          />

          <motion.div
            initial={{ scale: 0.7, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <LogoMark className="h-24 w-24" />
          </motion.div>

          <div className="relative mt-7 overflow-hidden">
            <motion.div
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 0.8, delay: 0.35, ease: [0.22, 1, 0.36, 1] }}
              className="font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl"
            >
              Core Loop <span className="text-cyber">Tech</span>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.7 }}
            className="relative mt-3 font-mono text-[11px] uppercase tracking-[0.4em] text-white/40"
          >
            Hong Kong
          </motion.div>

          <div className="relative mt-9 h-px w-44 overflow-hidden bg-white/10">
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: "0%" }}
              transition={{ duration: 1.9, ease: [0.4, 0, 0.2, 1] }}
              className="h-full w-full bg-cyber shadow-[0_0_12px_#00F0FF]"
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
